import MainHeaderSurvivor from './MainHeaderSurvivor';
export default MainHeaderSurvivor;